/**
 * DO NOT CHANGE THIS ENUM, in any case you can add more items
 * 
 * 
 * 
 */
export enum DigitalSignatureContractType {
    NONE,

    AAU_ATHLETE_TERMS_AND_CONDITIONS,
    AAU_ATHLETE_AGE_ATTESTATION_FORM,
    AAU_ATHLETE_CHILD_PHOTO_USSAGE_CONSENT,

    AAU_AGE_ADULT_SHOPPING_CART_CONFIRMATION_CHECKBOX,

    AAU_CLUB_A_B_C_PRE_APPLICATION,
    AAU_CLUB_A_TRADEMARK_AGREEMENT,
    AAU_CLUB_B_C_TRADEMARK_AGREEMENT,

    AAU_CLUB_TIER_1_PRE_APPLICATION,
    AAU_CLUB_TIER_3_PRE_APPLICATION,

    AAU_CLUB_TIER_1_3_TRADEMARK_AGREEMENT,

    AAU_ATHLETE_VERIFY_YOUR_IDENTITY,
    AAU_MPE,
    FREE_TO_USE_3,
    FREE_TO_USE_4,
    FREE_TO_USE_5,

    AAU_NON_ATHLETE_TERMS,

    AAU_EVENT_LICENSING_AGREEMENT,
    AAU_EVENT_LICENSING_FINAL_REVIEW,

    AAU_PRACTICE_LICENSING_AGREEMENT,
    AAU_PRACTICE_LICENSING_FINAL_REVIEW,
    AAU_21,
    AAU_CLUB_FLORIDA_BACKGROUND_SCREENING,
}

export interface DigitalSignature {
    digitalSignatureContractId: DigitalSignatureContractType,
    firstName?: string | null,
    lastName?: string | null,
    attributes?: string | null
}

export interface DigitalSignatureSign {
    id: number,
    digitalSignatureContractId: DigitalSignatureContractType,
    personId: number,
    firstName?: string | null,
    lastName?: string | null,
    sign?: string | null
}